import client from '@lib/http/client'

export const purchaseCredits = (amount: number) =>
  client.post(`/credits/purchase`, {
    amount
  })
